export default __webpack_public_path__ + "static/media/notice_img.0e210877.svg";